//请自行添加语言资源
const loginLog = {
  username: '用户名',
  ipAddress: 'IP地址',
  address: '登录地址',
  browserName: '浏览器名称',
  operateSystem: '操作系统',
  loginStatus: '登录状态',
  operateMsg: '操作信息',
  createTime: '创建时间',
  msg: {}
};
export default loginLog



// WEBPACK FOOTER //
// ./src/page/log/loginLog/lang/loginLog.zh.js